// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3d1n-","left":"styles_left__2YNxC","desktopActions":"styles_desktopActions__1W3YF","title":"styles_title__33Cbp"};